export const getAddressString = market =>
  `${market?.address?.street || market['address.street']}, ${
    market?.address?.zip || market['address.zip']
  } ${market?.address?.city || market['address.city']}`
